import Header from '../components/Header';
import AboutContent from '../components/About';
import Footer from '../components/Footer';
import DecorativeDivider from '../components/DecorativeDivider';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import StarField from '../components/StarField';
import './AboutPage.css';

export default function About() {

  return (
    <>
      <SEO
        title="Our Story"
        description="Meet the Adelaide-based husband and wife team behind Kids Vids. With TV production credits including McLeod's Daughters and The Bill, we bring professional editing quality to your family memories. Working with Children Check and Police Clearance certified."
        path="/about"
      />
      <StructuredData type="about" />
      <Header />
      <main>
        {/* Custom Hero Section for About Page */}
        <div className="about-page-hero film-strip">
          <div className="about-hero-background"></div>
          <div className="gradient-overlay-radial"></div>
          <div className="gradient-overlay-top"></div>

          {/* Floating stars for ambience */}
          <StarField starCount={75} containerClassName="about-hero-stars" />

          <div className="about-hero-content">
            <div className="about-title-box">
              <h1>Our Story</h1>
            </div>
          </div>
        </div>

        <DecorativeDivider />
        <AboutContent />
      </main>
      <Footer />
    </>
  );
}
